module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_bulb-ad9f34fbea2be0406bbce43b988126e9.png";